<template>
    <div>
        <template v-if="$store.getters.isLoggedIn && purchase.customer.id === $store.getters.getOrganization.id && purchase.private_data && purchase.private_data.proposals && isStatusProtocolFormedOrGreater">
            <template v-if="purchase.private_data.proposals && purchase.private_data.proposals.length > 0">
                <b-row>
                    <b-col md="10">
                        <h2 class="grey-color font-weight-bold my-3">Предложения участников</h2>
                    </b-col>
                </b-row>
                <private-fl223-proposal-card v-for="(proposal, index) in purchase.private_data.proposals" :key="'proposal_' + index" :proposal="proposal" :purchase-id="purchase.id" :supplier-requirements="purchase.supplier_requirements" :purchase="purchase" :index="index" :with-rating="true" />
            </template>
            <template v-if="purchase.private_data.proposals && purchase.private_data.proposals.length === 0">
                <b-row>
                    <b-col md="10">
                        <h2 class="grey-color font-weight-bold my-3">Конкурсные заявки отсутствуют</h2>
                    </b-col>
                </b-row>
            </template>
        </template>
        <template v-else-if="purchase.status.id === 'accepting' && purchase.private_data">
            <b-row>
                <b-col md="10">
                    <h2 class="grey-color font-weight-bold my-3">Предложения участников</h2>
                </b-col>
            </b-row>
            <p v-if="purchase.private_data.is_proposals_hidden">Период скрытия предложений участников в закупочной сессии наступил {{ $formatDateTimeIn(purchase.private_data.hide_proposals_at) }}</p>
            <p v-else>Предложения участников будут скрыты {{ $formatDateTimeIn(purchase.private_data.hide_proposals_at) }}</p>
            <b-table v-if="purchase.private_data.proposals" :fields="fields" :items="purchase.private_data.proposals" class="table-atmo" show-empty small responsive>
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(status)="data">
                    {{ data.item.status.title }} <span v-if="data.item.is_my_proposal" v-text="'(Моё)'" />
                </template>
                <template #cell(created_at)="data">
                    {{ $formatDateTime(data.item.created_at) }}
                </template>
                <template #cell(supplier)="data">
                    <span v-text="`Поставщик ${data.index + 1}`" />
                </template>
                <template #empty>
                    <div class="w-100 text-center">Нет поданных предложений</div>
                </template>
            </b-table>
        </template>
    </div>
</template>

<script>
import PrivateFl223ProposalCard from './private-fl223-proposal-card.vue';

export default {
    name: 'private-fl223-proposals-block',
    components: {
        PrivateFl223ProposalCard
    },
    props: {
        purchase: {}
    },
    data() {
        return {
            fields: [
                { key: 'index', label: '№', tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '1px' } },
                { key: 'status', label: 'Статус', tdClass: 'align-text-top py-1', thClass: 'text-nowrap py-1' },
                { key: 'created_at', label: 'Дата и время подачи', tdClass: 'align-text-top py-1 text-nowrap', thClass: 'py-1' },
                { key: 'supplier', label: 'Поставщик', tdClass: 'align-text-top py-1', thClass: 'py-1' },
            ],
        };
    },
    computed: {
        isStatusProtocolFormedOrGreater() {
            return !(this.purchase.status.id === 'draft' || this.purchase.status.id === 'signed' || this.purchase.status.id === 'accepting' || this.purchase.status.id === 'summarizing');
        }
    }
};
</script>
